import { render } from "./match-details-modal-footer.vue?vue&type=template&id=b2293e50&scoped=true&ts=true"
import script from "./match-details-modal-footer.vue?vue&type=script&lang=ts"
export * from "./match-details-modal-footer.vue?vue&type=script&lang=ts"

import "./match-details-modal-footer.vue?vue&type=style&index=0&id=b2293e50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2293e50"]])

export default __exports__